import { Menu } from "antd";
import { h } from "preact";
import { ISidebar } from "..";
import { SidebarComponent } from "../styled";
import { env } from "../../../../utils/env/config";

const SidebarDefault = ({
  listMenu,
  selectedMenu,
  collapsed,
  onCollapse,
}: ISidebar) => {
  return (
    <SidebarComponent
      // collapsible
      collapsed={collapsed}
      onCollapse={(c) => {
        onCollapse(c);
      }}
    >
      {
        (
          // @ts-expect-error - React/Preact type incompatibility with antd
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={selectedMenu}
            selectedKeys={selectedMenu}
          >
            {listMenu as React.ReactNode}
          </Menu>
        ) as React.ReactNode
      }
      <div
        style={{
          padding: "10px 16px",
          textAlign: "center",
          borderTop: "1px solid #f0f0f0",
          position: "absolute",
          bottom: 0,
          width: "100%",
        }}
      >
        {env.version}
      </div>
    </SidebarComponent>
  );
};

export default SidebarDefault;
